import SommercialSelect from './src/main';

/* istanbul ignore next */
SommercialSelect.install = function(Vue) {
  Vue.component(SommercialSelect.name, SommercialSelect);
};
export default SommercialSelect;



// WEBPACK FOOTER //
// ./src/components/my-element-select/index.js